import i18n from "@/i18ns/i18n.js";
const routes = [
  {
    path: "request-disconnect",
    component: () =>
      import(
        "@/views/RequestList/RequestDisconnect.vue" // RequestDisconnect
      ),
    children: [
      
    ],
    meta: {
      Title: "Danhh sách yêu cầu"
    }
  }
];

export default routes;
